/*

FILE: nav.js
DESCRIPTION: Methods for updating main nav state

*/

import { state } from './state';

const openMobileNav = () => {
	document.body.classList.add('mobile-nav-open');
	state.mobileNavOpen = true;
}

const closeMobileNav = () => {
	document.body.classList.remove('mobile-nav-open');
	state.mobileNavOpen = false;
}

const toggleMobileNav = (e) => {
	state.mobileNavOpen ? closeMobileNav() : openMobileNav();
}

export { closeMobileNav, toggleMobileNav }
